/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ErrorType } from '../../api/errorHandling';
import {
 commonReducers,
 CommonState,
 initialCommonState,
} from '../_common/commonReducers';

// Same DTO as result pictures: base64 Thumbnail (grid) + PicData (full) + Type.
export interface CardtimePicture {
 Id: number;
 PicWhen: string;
 KescId: number;
 UserName: string;
 Weighings: {
  Id: number;
  Time: string;
  Weight: number;
 };
 PicData: string;
 Thumbnail: string;
 Type: string;
}

interface CardtimesState extends CommonState {
 pictures: CardtimePicture[];
}

const initialState: CardtimesState = {
 ...initialCommonState,
 pictures: [],
};

const cardtimesSlice = createSlice({
 name: 'cardtimes',
 initialState,
 reducers: {
  ...commonReducers,
  getCardtimePicturesStart(state, _action: PayloadAction<number | string>) {
   return {
    ...state,
    loading: { ...state.loading, getCardtimePictures: true },
   };
  },
  getCardtimePicturesSuccess(
   state,
   action: PayloadAction<CardtimePicture[]>,
  ) {
   return {
    ...state,
    pictures: action.payload,
    success: { ...state.success, getCardtimePictures: true },
    loading: { ...state.loading, getCardtimePictures: null },
   };
  },
  getCardtimePicturesFailure(state, _action: PayloadAction<ErrorType>) {
   return {
    ...state,
    success: { ...state.success, getCardtimePictures: false },
    loading: { ...state.loading, getCardtimePictures: null },
   };
  },
  getCardtimePicturesFinish(state) {
   return {
    ...state,
    success: { ...state.success, getCardtimePictures: null },
    loading: { ...state.loading, getCardtimePictures: null },
   };
  },
 },
});

export const {
 getTableStart,
 getTableSuccess,
 getTableFailure,
 getTableFinish,

 getItemStart,
 getItemSuccess,
 getItemFailure,

 createItemStart,
 createItemSuccess,
 createItemFailure,
 createItemFinish,

 updateItemStart,
 updateItemSuccess,
 updateItemFailure,
 updateItemFinish,

 deleteItemsStart,
 deleteItemsSuccess,
 deleteItemsFailure,
 deleteItemsFinish,

 deleteItemStart,
 deleteItemSuccess,
 deleteItemFailure,
 deleteItemFinish,

 getTableStructureStart,
 getTableStructureSuccess,
 getTableStructureFailure,

 getItemDocumentsStart,
 getItemDocumentsSuccess,
 getItemDocumentsFailure,
 getItemDocumentsFinish,

 uploadItemDocumentsStart,
 uploadItemDocumentsSuccess,
 uploadItemDocumentsFailure,
 uploadItemDocumentsFinish,

 deleteItemDocumentStart,
 deleteItemDocumentSuccess,
 deleteItemDocumentFailure,
 deleteItemDocumentFinish,

 getTableExcelStart,
 getTableExcelSuccess,
 getTableExcelFailure,
 getTableExcelFinish,

 getCardtimePicturesStart,
 getCardtimePicturesSuccess,
 getCardtimePicturesFailure,
 getCardtimePicturesFinish,
} = cardtimesSlice.actions;
export default cardtimesSlice;
